var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.svg)?_c('icon',{staticClass:"g_visual",attrs:{"src":_vm.svg}}):(_vm.fontIcon)?_c('i',{class:_vm.fontIcon}):_c('img',{directives:[{name:"img-src",rawName:"v-img-src",value:(_vm.src),expression:"src"}],staticClass:"g_visual"})}
var staticRenderFns = []

export { render, staticRenderFns }